const DEFAULT_TASK_TITLE = "New project task";
const MAX_TASK_TITLE_LENGTH = 80;

/**
 * Produces a stable, editable task-title suggestion from the first useful
 * thought in a project prompt. This stays client-side: the Tasks API accepts
 * only a title and an optional session id.
 */
export function suggestProjectTaskTitle(
  prompt: string,
  fallback = DEFAULT_TASK_TITLE,
): string {
  const firstLine = prompt
    .split(/\r?\n/)
    .map((line) => line.trim().replace(/^(?:[-*•]\s+|\d+[.)]\s+)/, ""))
    .find(Boolean);

  if (!firstLine) return fallback;

  const firstSentence = firstLine.match(/^(.+?[.!?])(?:\s|$)/)?.[1] ?? firstLine;
  const normalized = firstSentence.replace(/\s+/g, " ").trim();
  if (normalized.length <= MAX_TASK_TITLE_LENGTH) return normalized;

  const clipped = normalized.slice(0, MAX_TASK_TITLE_LENGTH - 1);
  const lastSpace = clipped.lastIndexOf(" ");
  return `${(lastSpace > 24 ? clipped.slice(0, lastSpace) : clipped).trim()}…`;
}

export { DEFAULT_TASK_TITLE, MAX_TASK_TITLE_LENGTH };
